import { Button, Stack, Typography } from '@mui/material'
import { SimplePageWrapper } from '../simple-page-wrapper/SimplePageWrapper'
import { VerificationCodeInput } from '~/@biz_account/phone-verify/codeInput/VerificationCodeInput'
import { Header } from '~/@ui/header/Header'

interface Props {
  title: string
  stopVerification: any
  getValues: any
  verificationCode: any
  handleCodeChange: any
  verifyCodeInputClassName: any
  state: any
  secondsLeft: any
  handleSendAgainClick: any
  showGdrp?: boolean
}

export const CodeInput = ({
  title,
  stopVerification,
  getValues,
  verificationCode,
  handleCodeChange,
  verifyCodeInputClassName,
  state,
  secondsLeft,
  handleSendAgainClick,
  showGdrp,
}: Props) => {
  return (
    <SimplePageWrapper onClickBack={stopVerification}>
      <Stack className="w-full max-w-[768px] self-center gap-8 px-5">
        <Header
          title={title}
          text={`Na číslo ${getValues('phonePrefix')} ${getValues('phoneNumber')} sme zaslali kód na overenie.`}
          className="pt-6"
        />

        <VerificationCodeInput
          value={verificationCode}
          onChange={handleCodeChange}
          stateClassName={verifyCodeInputClassName}
        />
      </Stack>

      <Stack className="items-center gap-8 mt-3">
        <Typography className="text-xs font-semibold text-zBlack200">
          {state ? `(Zostáva ${secondsLeft}s sekúnd)` : '(Neplatný kód)'}
        </Typography>
        <Stack className="items-center mt-0.5">
          <Typography className="text-sm font-medium text-zGrey400">
            Neprišiel vám SMS kód?
          </Typography>
          <Button
            variant="text"
            onClick={handleSendAgainClick}
            disabled={state}
            className="min-h-5 h-5 underline">
            <Typography
              className="text-sm font-semibold"
              sx={(theme) => ({
                color: state
                  ? theme.palette.custom.zGrey550
                  : theme.palette.custom.zBlack200,
              })}>
              Odoslať znova
            </Typography>
          </Button>
          {showGdrp && (
            <Typography
              variant="caption"
              className="mt-8 text-xs text-zGrey400">
              Zadaním kódu súhlasíte so spracovaním{' '}
              <Typography
                component="a"
                href="https://bonaship.sk/gdpr/ochrana-osobnych-udajov"
                target="_blank"
                rel="noopener noreferrer"
                variant="caption"
                className="underline underline-offset-2 cursor-pointer">
                osobných údajov
              </Typography>
              .
            </Typography>
          )}
        </Stack>
      </Stack>
    </SimplePageWrapper>
  )
}
